import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    Renderer2
} from '@angular/core';

@Directive({
    selector: '[canopyNumberOnly]'
})
export class NumberOnlyDirective {
    // Allow decimal numbers and negative values
    //private regex: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
    private regex: RegExp = new RegExp(/^-?(\.?)+[0-9]+(\.[0-9]*){0,1}$/g);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array < string > = ['Backspace', 'Tab', 'End', 'Home', '-'];

    private prevValue:string = "";

    @Input() minValue: number = 0;
    @Input() maxValue: number = 999999999999;

    constructor(private el: ElementRef,private renderer: Renderer2) {}
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        let current: string = this.el.nativeElement.value;
        let next: string = current==="0"?event.key:current.concat(event.key);

        if (next && !String(next).match(this.regex)) {
            let tmpVal = `${current}${next}`;
            // if the combined strings don't match then prevent it.
            // allow numbers to start with a decimal
            if(!String(tmpVal).match(this.regex) && tmpVal !== '.')
              event.preventDefault();
        }

        setTimeout(_ => this.prevValue = next, 100);

    }

    @HostListener('keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {
      let current: string = this.el.nativeElement.value;
      let newVal:any = current;
      let stopProp = false;
      
      if(parseInt(current) < this.minValue || parseInt(current) > this.maxValue){
        newVal = parseInt(current) > this.maxValue?this.maxValue:this.minValue;
        this.el.nativeElement.value = newVal;
        stopProp = true;
      }

      if(isNaN(parseFloat(current))){
        // preprend a zero if the first char is a decimal
        newVal = current === '.'?'0.':'';
        this.el.nativeElement.value = newVal;
        stopProp = true;
      }

      if(stopProp){
        event.stopImmediatePropagation();
        event.preventDefault();
      }

    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/number-only.directive.ts